import { mapActions, mapState } from "vuex";
import SummaryLine from "../chart-types/summary-line";
import i18n from "../../../plugins/i18n";

export default {
  name: "LactationChart",
  components: { SummaryLine },
  data: () => ({
    categories: {
      calving: {
        name: i18n.t("cowGenerics.cowLogs.Calving")
      },
      fresh: {
        name: i18n.t("dashboardView.charts.lactation.fresh")
      },
      lactatingWithoutFresh: {
        name: i18n.t("dashboardView.charts.lactation.lactatingWithoutFresh")
      },
      dry: {
        name: i18n.t("cowGenerics.cowLogs.Dry")
      }
    }
  }),
  computed: {
    ...mapState({
      /**
       * Gather lactation chart data from state and format it to display
       * @param {object} state The main state object
       */
      chartData(state) {
        // Count the total amount of lactation report
        const total = Object.values(state.chart.lactation).reduce((a, b) => a + b, 0);

        // Format data to display
        return Object.keys(this.categories).map((categories) => ({
          data: state.chart.lactation[categories],
          key: categories,
          name: this.categories[categories].name,
          // Check for division by zero
          percentage: total == 0 ? 0 : (state.chart.lactation[categories] / total) * 100
        }));
      },
      isFetching: state => state.chart.isFetching
    })
  },
  methods: {
    ...mapActions("chart", {
      getLactationChart: "getLactationChart",
      clearChart: "clearChart"
    })
  },
  mounted() {
    this.getLactationChart();
  },
  destroyed() {
    this.clearChart();
  }
};



// WEBPACK FOOTER //
// ./src/components/_charts/lactation/lactation-chart.js